







import Vue from 'vue' // eslint-disable-line no-unused-vars

export default {
  name: 'app-update-modal',
  components: {
  },
  data() {
    return {
    }
  },
  mounted() {
  },
  methods: {
  },
  computed: {
    appIsUpdating() {
      return this.$store.state.time.appIsUpdating
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/update-progress.vue